import { render } from "./ReadCard.vue?vue&type=template&id=0b5bdb70&scoped=true"
import script from "./ReadCard.vue?vue&type=script&lang=js"
export * from "./ReadCard.vue?vue&type=script&lang=js"

import "./ReadCard.vue?vue&type=style&index=0&id=0b5bdb70&lang=scss&scoped=true"

import exportComponent from "/apps/srv/jenkins/workspace/feihua_fe_mguoxueweb_online/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b5bdb70"]])

export default __exports__